import type { FlexProps, StyleProps } from "@chakra-ui/react";
import { Flex, Image } from "@chakra-ui/react";
import circle_bottom_center from "assets/images/page_backgrounds/circle_bottom_center.svg";
import tigerCloudLogo from "assets/logos/tigerdata-logo.svg";
import type { ReactNode } from "react";

interface CenteredBackgroundLayoutProps extends FlexProps {
  children: ReactNode;
  showLogo?: boolean;
  logoStyles?: StyleProps;
}

export const CenteredBackgroundLayout = ({
  children,
  showLogo = false,
  logoStyles,
  ...flexProps
}: CenteredBackgroundLayoutProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    backgroundImage={{ base: `url(${circle_bottom_center})` }}
    backgroundRepeat="no-repeat"
    backgroundSize="2000px"
    backgroundPosition="center calc(50% + 900px)"
    height="100vh"
    width="100%"
    backgroundColor="bg.container"
    data-cy="centered-background-layout"
    {...flexProps}
  >
    {showLogo && (
      <Flex
        minW="516px"
        gap="6"
        alignItems="center"
        flexDir="column"
        mx="auto"
        position="absolute"
        top="100px"
        {...logoStyles}
      >
        <Image w="48" h="41px" mb="8" src={tigerCloudLogo} />
      </Flex>
    )}
    {children}
  </Flex>
);
